import Auth from "./Auth/Reducer";
import General from "./General/Reducer";
import GamesData from "./GamesData/Reducer";

export default { Auth, General, GamesData };
